let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("6wr18"), load("ffEVr"), load("bP7LP")]).then(() => parcelRequire('6Ecy6'));